var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    strokeWidth: 3,
    stroke: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.562 18.75a2 2 0 00-2.811-.312l-15.001 12a2 2 0 000 3.124l15 12a1.997 1.997 0 002.811-.312 2 2 0 00-.312-2.811L6.201 32.001l13.048-10.438a2 2 0 00.312-2.811zM47.25 18.438a2 2 0 10-2.499 3.123l13.048 10.438-13.048 10.438a2 2 0 002.499 3.123l15-12a2 2 0 000-3.124l-15-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.539 5.074a2 2 0 00-2.465 1.387l-14 50a2 2 0 003.852 1.079l14-50.001a2 2 0 00-1.387-2.465z",
    "data-color": "color-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventManagement);
export default __webpack_public_path__ + "static/media/event-management.13130470.svg";
export { ForwardRef as ReactComponent };